exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabs[data-v-f66983c2] {\n  margin-bottom: 1.5rem;\n}\n", ""]);

// exports
